import React from 'react';

const NebulaUserProfileFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaUserProfileModalRegistry = {
    personalize_nebulaUserProfileId: NebulaUserProfileFormModal
};
export default nebulaUserProfileModalRegistry;
